import { LoaderFunctionArgs, ShouldRevalidateFunction, defer, redirect } from "react-router-dom";
import { fetchLensHome, fetchProfileExportConfigs } from "redux/slices/clientLens";
import { ensureLookerEmbeds } from "redux/slices/clientLens";
import store from "redux/store";

export const lensLoader = async (args: LoaderFunctionArgs) => {
  const lensId = parseInt(args.params.lensId || "");

  if (isNaN(lensId)) {
    return redirect("..");
  }

  return defer({
    await: await store
      .dispatch(fetchLensHome({ lensId }))
      .unwrap()
      .catch(() => {
        return redirect("/lens");
      }),
    defer: Promise.all([
      store
        .dispatch(ensureLookerEmbeds({ lensId }))
        .unwrap()
        .catch(() => {
          return redirect("/lens");
        }),
      store.dispatch(fetchProfileExportConfigs({ lensId })),
    ]),
  });
};

export const shouldRevalidateLens: ShouldRevalidateFunction = (params) => {
  const { currentParams, nextParams } = params;
  return currentParams.lensId !== nextParams.lensId;
};
